const formatters = new Map();

const getFormatter = (fractionDigits) => {
  if (!formatters.has(fractionDigits)) {
    formatters.set(
      fractionDigits,
      new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      })
    );
  }

  return formatters.get(fractionDigits);
};

export const formatAmount = (value, fractionDigits = 2) => {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

  return getFormatter(fractionDigits)
    .format(safeValue)
    .replace(/[\u00A0\u202F]/g, ' ');
};
